
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { LanguageModel } from './Language.Api.Models.Language';
import { Model, ModelProperty } from 'models/Model';


export class LanguageVariableModel extends Model<LanguageVariableModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'identifier', type: 'string' },
		{ name: 'text', type: 'string' },
		{ name: 'languageIsoCode', type: 'string' },
		{ name: 'updated', type: 'Date' },
		{ name: 'languageIsoCodeNavigation', type: 'LanguageModel', isHidden: true, isObject: true, new: () => { return new LanguageModel }, properties: () => { return LanguageModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public identifier: string;
	public text: string;
	public languageIsoCode: string;
	public updated?: Date;
	public languageIsoCodeNavigation?: LanguageModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.identifier = '';
		this.text = '';
		this.languageIsoCode = '';
		this.updated = undefined;
		this.languageIsoCodeNavigation = undefined;
		
	}
	getProperties(){
		return LanguageVariableModel.classProperties;
	}
}

